"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BannerTextLinkClassName = exports.BANNER_TEXT_LINK = exports.BANNER_TEXT_CAPTION = exports.BANNER_TEXT = void 0;
const BANNER_TEXT = exports.BANNER_TEXT = 'banner-text';
const BANNER_TEXT_LINK = exports.BANNER_TEXT_LINK = 'banner-text-link';
const BANNER_TEXT_CAPTION = exports.BANNER_TEXT_CAPTION = 'banner-text-caption';
const BannerTextLinkClassName = exports.BannerTextLinkClassName = 'banner-text-link';
